

<div class="container text-center mt-4" *ngIf="promotionsVisibles.length >0" >
  <span style="color: var(--secondary-color)" class="fs-1 fw-bolder">Promociones <span class="fw-normal">destacadas</span></span>
</div>

<div class="cards row ">
  <div class="col-4 px-0 card card--1" *ngFor="let item of promotionsVisibles">

    <a  [className]="item.categoria">
      <div class="card__img" [ngStyle]="{'background-image': 'url(' + serverImgenUrl + item.imagenPromocion + ')'}">
      </div>
      <span class="card_link">
              <div class="card__img--hover" [ngStyle]="{'background-image': 'url(' + serverImgenUrl + item.imagenPromocion + ')'}"></div>
            </span>
      <div class="card__info text-center">
        <span class="fs-6 text-secondary fw-bold">{{ item.especialidad }}</span>
        <h3 class="fs-6 fw-bolder">{{ item.nombre }}</h3>
        <strong> <span style="color: var(--secondary-color)" class="fs-6 fw-bolder">${{ item.precio }}</span><br></strong>
        <button [routerLink]="['/promociones', item.codPromocionSam]" style="font-size: 1.1rem; background-color: var(--primary-color)" class="btn w-100 badge viewMore rounded-pill">
          Ver más <i class="bi bi-search"></i>
        </button>
      </div>
    </a>

  </div>

</div>
